import React from 'react';
import { Row, Col, Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import { debounce } from 'utils/debounce';
import { getErrorIssues, getWarningIssues } from '../../../../../../../utils/validationSummary';
import { locations } from '../../../../../../../utils/locationValues';
import { fetchProjectLocation, updateProjectLocation } from '../../../../../../../actions';
import { displayValueofTimeZones } from '../../../../../../../utils/locationValues';
import { Trans } from 'react-i18next';

class LocationComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            dropdownValue: "",

            latitude: null,
            longitude: null,
            timeZone: null,

            customAvailableTimeZones: null,
            customSelectedTimeZone: null,
        };

        this.handleChange = this.handleChange.bind(this);

        this.handleChangeLatitude = this.handleChangeLatitude.bind(this);
        this.handleChangeLongitude = this.handleChangeLongitude.bind(this);
        this.renderTimeZones = this.renderTimeZones.bind(this);
        this.handleChangeTimeZone = this.handleChangeTimeZone.bind(this);
    }

    componentDidMount() {

        // Fetch of the project
        this.props.fetchProjectLocation(this.props.project.id).then(() => {

            // case were projectLocation is null
            if (!this.props.projectLocation) {
                const newOffset = this.getConvertedOffset(locations[0].offset);
                this.setState({
                    dropdownValue: locations[0],
                    latitude: ((locations[0].latitude << 16) >> 16) / 8,
                    longitude: ((locations[0].longitude << 16) >> 16) / 8,
                    timeZone: newOffset,
                });
                return;
            }

            this.setState({
                latitude: this.props.projectLocation.latitude,
                longitude: this.props.projectLocation.longitude,
                timeZone: this.props.projectLocation.timeZone,
            });

            if (!this.props.midnightShift) {
                this.props.updateProjectLocation(this.props.project.id, this.props.projectLocation.latitude, this.props.projectLocation.longitude, this.props.projectLocation.timeZone);
            }

            const latitude = this.props.projectLocation.latitude * 8;
            const longitude = this.props.projectLocation.longitude * 8;
            const timeZone = this.props.projectLocation.timeZone;

            for (let i = 0; i < locations.length; i++) {
                const newOffset = this.getConvertedOffset(locations[i].offset);
                // we found correct location
                if (latitude === locations[i].latitude
                    && (((longitude << 16) >> 16) / 8) === (((locations[i].longitude << 16) >> 16) / 8)
                    && timeZone === newOffset) {

                    this.setState({
                        dropdownValue: locations[i].name,
                    });
                    return;
                }
            }

            let utc = this.getUTCFromOffset(this.props.projectLocation.timeZone);
            if(this.props.projectLocation.timeZone===5.75){
                utc=utc.replace(/(\.0+|0+)$/, '');
            }
            const timeZones = displayValueofTimeZones(this.props.projectLocation.longitude);
            this.setState({
                dropdownValue: locations[1].name,
                customAvailableTimeZones: timeZones,
                customSelectedTimeZone: utc
            });

        });
    }

    renderDropdownItems() {

        let dropdownItems = [];

        locations.forEach(prop => {

            dropdownItems.push(
                <Dropdown.Item onClick={this.handleChange} name={prop.name} key={prop.name} >{prop.name}</Dropdown.Item>
            );
        });

        return dropdownItems;
    }

    handleUpdateProject = debounce(() => this.props.onUpdateProject(), 500);

    handleChange(e) {
        const value = e.target.name;

        for (let i = 0; i < locations.length; i++) {
            if (value === locations[i].name) {

                const latitude = ((locations[i].latitude << 16) >> 16) / 8;
                const longitude = ((locations[i].longitude << 16) >> 16) / 8;
                const timeZone = this.getConvertedOffset(locations[i].offset);

                this.setState({
                    dropdownValue: locations[i].name,
                    latitude: latitude,
                    longitude: longitude,
                    timeZone: timeZone,
                });

                this.props.updateProjectLocation(this.props.project.id, latitude, longitude, timeZone);
                this.handleUpdateProject();

                if (value === 'Custom') {
                    const utc = this.getUTCFromOffset(timeZone);
                    const timeZones = displayValueofTimeZones(utc);
                    this.setState({
                        customAvailableTimeZones: timeZones,
                        customSelectedTimeZone: timeZones[0]
                    });
                }

                return;
            }
        }
    }

    getConvertedOffset(value) {

        if (value <= 64) {
            value = value / 4;
        } else {
            value = (value - 128) / 4;
        }

        return value;
    }

    getUTCFromOffset(offset) {

        if (offset % 1 === 0) {
            if (offset >= 0) {
                return "UTC+" + offset.toString().padStart(2, "0") + ":00";
            } else {
                return "UTC-" + (offset * -1).toString().padStart(2, "0") + ":00";
            }
        }

        const tmpValue = ('' + offset).split('.');
        const hourValue = +tmpValue[0] > 0 ? +tmpValue[0] : (+tmpValue[0] * -1);
        const minutesValue = +tmpValue[1] * 6;

        if (offset >= 0) {
            return "UTC+" + hourValue.toString().padStart(2, "0") + ":" + minutesValue.toString().padStart(2, "0");
        } else {
            return "UTC-" + (hourValue * -1).toString().padStart(2, "0") + ":" + minutesValue.toString().padStart(2, "0");
        }
    }

    getOffsetFromUTC(utc) {

        const aa = utc.replace("UTC", '');
        let hours = "00";
        let minutes = "00";

        if (aa !== '') {
            hours = aa.substring(1, 3);
            minutes = aa.substring(4, 6);
        }
        return (+(hours + "." + (+minutes / 6)*10)) * (aa[0] === '+' ? 1 : -1);
    }

    handleChangeLatitude(e) {
        const v = e.target.value;
        this.setState({ latitude: v });

        this.props.updateProjectLocation(this.props.project.id, +v, this.state.longitude, this.getOffsetFromUTC(this.state.customSelectedTimeZone));
        this.handleUpdateProject();
    }

    handleChangeLongitude(e) {
        const v = e.target.value;
        const timeZones = displayValueofTimeZones(v);
        this.setState({ longitude: v, customAvailableTimeZones: timeZones });
        this.props.updateProjectLocation(this.props.project.id, this.state.latitude, +v, this.getOffsetFromUTC(this.state.customSelectedTimeZone));
        this.handleUpdateProject();
        // let found = false;
        // for (var i = 0; i < timeZones.length; i++) {
        //     if (timeZones[i] === this.state.customSelectedTimeZone) {
        //         found = true;
        //         break;
        //     }
        // }

        // if (!found) {
        //     this.setState({ customSelectedTimeZone: timeZones[0] });
        //     this.props.updateProjectLocation(this.props.project.id, this.state.latitude, +v, this.getOffsetFromUTC(timeZones[0]));
        // } else {
        //     this.props.updateProjectLocation(this.props.project.id, this.state.latitude, +v, this.getOffsetFromUTC(this.state.customSelectedTimeZone));
        // }
    }

    handleChangeTimeZone(e) {
        const value = e.target.name;
        this.setState({ customSelectedTimeZone: value });

        this.props.updateProjectLocation(this.props.project.id, this.state.latitude, this.state.longitude, this.getOffsetFromUTC(value));
        this.handleUpdateProject();
    }

    renderTimeZones() {

        let dropdownItems = [];

        if (this.state.customAvailableTimeZones) {
            this.state.customAvailableTimeZones.forEach(prop => {

                dropdownItems.push(
                    <Dropdown.Item onClick={this.handleChangeTimeZone} name={prop} key={prop} >{prop}</Dropdown.Item>
                );
            });
        }

        return dropdownItems;
    }

    render() {

        const errors = getErrorIssues(this.props.issues, this.props.property);
        const warnings = getWarningIssues(this.props.issues, this.props.property);

        const className = `edit-icon-project-header dropdown-inventronics ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

        //const newOffSet = this.state.timeZone === null ? '' : this.getConvertedOffset(this.state.timeZone);
        const UTC = this.state.timeZone === null ? '' : this.getUTCFromOffset(this.state.timeZone);

        //const shift = this.state.timeZone === null ? '' : calculateMidnightShift(this.state.timeZone, this.state.dropdownValue ? ((this.state.dropdownValue.latitude << 16) >> 16) / 8 : 0, this.state.dropdownValue ? ((this.state.dropdownValue.longitude << 16) >> 16) / 8 : 0);

        const isCustom = this.state.dropdownValue === 'Custom' ? true : false;

        return (
            <div>
                <Row style={{ margin: this.props.margin }}>
                    <Col sm={3} style={{ padding: this.props.paddingTitle }}><Trans i18nKey="Location" /></Col>
                    <Col sm={5} style={{ padding: "0" }}>
                        <Dropdown>
                            <Dropdown.Toggle variant="secondary" disabled={this.props.disabled} className={className}>{this.state.dropdownValue}</Dropdown.Toggle>
                            <Dropdown.Menu style={{ minWidth: "auto", fontSize: "14px" }}>
                                {this.renderDropdownItems()}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                </Row>

                <br />

                <Row style={{ margin: this.props.margin }}>
                    <Col sm={3} style={{ padding: this.props.paddingTitle }}><Trans i18nKey="Latitude" /></Col>
                    <Col sm={3} style={{ padding: "0" }}>
                        <input
                            disabled={this.props.disabled || !isCustom}
                            className="input-property-picker"
                            name="latitude"
                            type="number"
                            min={-65}
                            max={65}
                            step={0.1}
                            onChange={this.handleChangeLatitude}
                            value={this.state.latitude || ""} />
                    </Col>
                    <Col sm={3} style={{ padding: this.props.paddingTitle }}><Trans i18nKey="Longitude" /></Col>
                    <Col sm={3} style={{ padding: "0" }}>
                        <input
                            disabled={this.props.disabled || !isCustom}
                            className="input-property-picker"
                            name="longitude"
                            type="number"
                            min={-180}
                            max={180}
                            step={0.1}
                            onChange={this.handleChangeLongitude}
                            value={this.state.longitude || ""} />
                    </Col>
                </Row>

                <br />

                <Row style={{ margin: this.props.margin }}>
                    <Col sm={3} style={{ padding: this.props.paddingTitle }}><Trans i18nKey="Time_Zone" /></Col>
                    <Col sm={3} style={{ padding: "0" }}>
                        {
                            !isCustom

                                ? <input
                                    disabled={true}
                                    className="input-property-picker"
                                    name="timeZone"
                                    value={UTC} />

                                : <Dropdown>
                                    <Dropdown.Toggle variant="secondary" disabled={this.props.disabled} className={className}>{this.state.customSelectedTimeZone}</Dropdown.Toggle>
                                    <Dropdown.Menu style={{ minWidth: "auto", fontSize: "14px" }}>
                                        {this.renderTimeZones()}
                                    </Dropdown.Menu>
                                </Dropdown>
                        }
                    </Col>
                    <Col sm={3} style={{ padding: this.props.paddingTitle }}><Trans i18nKey="MidNight_Shift" /></Col>
                    <Col sm={3} style={{ padding: "0" }}>
                        <input
                            disabled
                            className="input-property-picker"
                            name="midNightShift"
                            value={this.props.midnightShift ? this.props.midnightShift : 0} />
                    </Col>
                </Row>
            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        projectLocation: state.project.location,
        midnightShift: state.project.midnightShift,
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
    fetchProjectLocation,
    updateProjectLocation,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LocationComponent);
